import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

const Role = ({ children }) => {
  const [roleCheck, setRoleCheck] = useState(false);
  const navigate = useNavigate();
  const isAuthenticated = () => {
    const role = localStorage.getItem("role");
    if (role != "user") {
      setRoleCheck(true);
    } else {
      setRoleCheck(true);

      // navigate("/no-access");
    }
    return false;
  };
  useEffect(() => {
    isAuthenticated();
  });
  return <>{roleCheck ? <div>{children}</div> : <>{"Loading"}</>}</>;
};

export default Role;
